// extracted by mini-css-extract-plugin
export default {"Restart":"Restart_Restart__o6z9X"};